import React, { useState, useEffect, useRef } from 'react';
import { getStyle } from '@coreui/utils';
import { CChart } from '@coreui/react-chartjs';
import { BASE_URL } from "../../App";
import axios from 'axios';
import Chart from 'chart.js';

const ChartDoughnutAndPieExample = () => {
  const chartRef = useRef(null);

  const login_id = localStorage.getItem("LOGIN_ID");
  const USER_ID = localStorage.getItem("USER_ID");

  const [chartData, setChartData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()); // Set default to current month
  const [loading, setLoading] = useState(false); // Add loading state
  const [noData, setNoData] = useState(false); // Add noData state

  // Array of month names to map numbers to their corresponding names
  const monthNames = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];

  // Fetch chart data from API
  const fetchChartData = async (monthName) => {
    setLoading(true); // Set loading to true when fetching data
    try {
      const response = await axios.post(BASE_URL + '/customer_enquery_piechart', {
        userid: USER_ID,
        selectmonth: monthName, // Send the month name (e.g., 'January')
      });

      const data = response.data.data;
      
      if (data && data.length > 0) {
        const newChartData = {
          labels: data.map(item => item.status), // Labels for the chart (status names)
          datasets: [
            {
              backgroundColor: generateRandomColors(data.length), // Generate random colors for the chart
              data: data.map(item => parseInt(item.total_calls)), // Convert total_calls to integers
            },
          ],
        };
        
        setChartData(newChartData);
        setNoData(false); // Set noData to false if data is available
      } else {
        setNoData(true); // Set noData to true if no data is returned
      }
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setNoData(true); // Set noData to true if there is an error
    } finally {
      setLoading(false); // Set loading to false once fetching is complete
    }
  };

  // Generate random colors
  const generateRandomColors = (numColors) => {
    const colors = [];
    for (let i = 0; i < numColors; i++) {
      const randomColor = `#${Math.floor(Math.random()*16777215).toString(16)}`;
      colors.push(randomColor);
    }
    return colors;
  };

  useEffect(() => {
    fetchChartData(monthNames[selectedMonth]); // Fetch data based on selected month
  }, [selectedMonth]); // When selectedMonth changes, trigger data fetch

  // Handle dropdown change for month selection
  const handleMonthChange = (event) => {
    setSelectedMonth(Number(event.target.value) - 1); // Subtract 1 to match the month index
  };
  
const options = {
  plugins: {
    legend: {
      labels: {
        color: getStyle('--cui-body-color'),
      },
    },
    tooltip: {
      enabled: true, // Enable tooltips
      mode: 'index', // Tooltip shows data for all datasets at the hovered position
      intersect: false, // Ensure the tooltip shows even when not directly over a data point
      backgroundColor: 'rgba(0, 0, 0, 0.7)', // Background color of the tooltip
      titleColor: '#fff', // Tooltip title color
      bodyColor: '#fff', // Tooltip body text color
      callbacks: {
        // Custom tooltip content
        label: function(tooltipItem) {
          const label = tooltipItem.label || ''; // Get label for the segment
          const value = tooltipItem.raw || 0; // Get the value of the hovered segment

          // Get the total value of all segments
          const total = tooltipItem.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);

          // Calculate the percentage
          const percentage = ((value / total) * 100).toFixed(2);

          // Return formatted tooltip label with value and percentage
          return `${label}: ${value} calls (${percentage}%)`;
        }
      }
    },
  },
  elements: {
    arc: {
      // Override the arc properties
      borderWidth: 3
    }
  },
  animation: {
    animateRotate: true,
    animateScale: true
  }
};


  return (
    <div className='row'>
      <div className='col-md-8'>
        <h3>Month Service Calls Count</h3>
        <div className="chart-container" style={{ position: 'relative' }}>
          <div className="month-selector" style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 10 }}>
            <select value={selectedMonth + 1} onChange={handleMonthChange}>
              {Array.from({ length: 12 }, (_, index) => (
                <option key={index} value={index + 1}>
                  {monthNames[index]}  {/* Display the month name */}
                </option>
              ))}
            </select>
          </div>

          {/* Show loading message while fetching data */}
          {loading && <div>Loading...</div>}

          {/* Show no data message if no data is available */}
          {noData && !loading && <div>No data available for {monthNames[selectedMonth]}</div>}

          {/* Render the chart if data is available */}
          {!loading && !noData && <CChart type="doughnut" data={chartData} options={options} ref={chartRef} />}
        </div>
      </div>
    </div>
  );
};

export default ChartDoughnutAndPieExample;
